import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  StyledSelectInput,
  StyledSelectOption,
  StyledSelectOptions,
  StyledSelectValue,
  StyledSelectValueWrapper,
  StyledSelectWrapper,
} from "./SelectStyles";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useLanguageContext } from "../../../context/LanguageContext";
import ReactDOM from "react-dom";

function SelectView({
  id,
  value,
  search,
  searchable,
  disabled,
  focused,
  options,
  highlightedIndex,
  getOptionId,
  searchRef,
  selectRef,
  optionsRef,
  optionsPortal,
  onSearchChange,
  onValueChange,
  onKeyDown,
  onKeyUp,
  onSelectClick,
  onSelectMouseDown,
  onSelectBlur,
  onOptionsMouseDown,
  onOptionHover,
  as: Element = StyledSelectWrapper,
  hideCaret = false,
  valueVisual = (option) => option?.label,
  placeholder,
  title,
  style,
}) {
  const { translate } = useLanguageContext();
  const listboxId = `${id}-listbox`;
  const activeDescendant =
    focused && highlightedIndex >= 0 ? getOptionId(highlightedIndex) : undefined;

  return (
    <>
      <Element
        ref={selectRef}
        disabled={disabled}
        title={title}
        style={style}
        tabIndex={disabled ? -1 : 0}
        role="combobox"
        aria-haspopup="listbox"
        aria-expanded={focused}
        aria-controls={listboxId}
        aria-activedescendant={activeDescendant}
        aria-disabled={disabled}
        aria-label={title}
        onClick={onSelectClick}
        onMouseDown={onSelectMouseDown}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onBlur={onSelectBlur}
      >
        <StyledSelectValueWrapper>
          <StyledSelectValue>
            {valueVisual(value) ??
              placeholder ??
              translate("eva.main.general.select")}
          </StyledSelectValue>

          {focused && searchable && (
            <StyledSelectInput
              ref={searchRef}
              value={search}
              tabIndex={-1}
              aria-autocomplete="list"
              aria-controls={listboxId}
              aria-activedescendant={activeDescendant}
              aria-label={title ?? translate("eva.main.general.search")}
              onChange={onSearchChange}
            />
          )}
        </StyledSelectValueWrapper>

        {!hideCaret && <FontAwesomeIcon icon={faCaretDown} size="sm" />}

        {optionsPortal &&
          ReactDOM.createPortal(
            <StyledSelectOptions
              ref={optionsRef}
              id={listboxId}
              role="listbox"
              $hide={`${!focused}`}
              onMouseDown={onOptionsMouseDown}
            >
              {focused &&
                options.map((option, index) => (
                  <StyledSelectOption
                    key={`${option.value}`}
                    id={getOptionId(index)}
                    role="option"
                    aria-selected={value?.value === option.value}
                    aria-disabled={option.disabled ?? false}
                    onClick={() => onValueChange(option.value)}
                    onMouseMove={() => onOptionHover(index)}
                    $active={`${value?.value === option.value}`}
                    $highlighted={`${highlightedIndex === index}`}
                    disabled={option.disabled ?? false}
                  >
                    {option.label}
                  </StyledSelectOption>
                ))}

              {focused && options.length < 1 && (
                <StyledSelectOption>
                  {translate("eva.main.general.no_results")}
                </StyledSelectOption>
              )}
            </StyledSelectOptions>,
            optionsPortal,
          )}
      </Element>
    </>
  );
}

export default SelectView;
